export default {
  id: "catalog-item",
  name: "Catalog Item",
  settings: {}
};
